
/* styles */
require("!!../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true,\"publicPath\":\"/\"}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../vue-loader/lib/style-compiler/index?{\"id\":\"data-v-21428e1a\",\"scoped\":false,\"hasInlineConfig\":false}!sass-loader?{\"data\":\"\\n    @import '~@/scss/auto-import';\\n  \",\"sourceMap\":true}!../vue-loader/lib/selector?type=styles&index=0!./switches.vue")

var Component = require("!../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!eslint-loader!../vue-loader/lib/selector?type=script&index=0!./switches.vue"),
  /* template */
  require("!!../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-21428e1a\"}!../vue-loader/lib/selector?type=template&index=0!./switches.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-switches/switches.vue
// module id = 312
// module chunks = 1